import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { SubscriptionService } from "../service/subscription.service";

@Injectable({
    providedIn: "root"
})
export class ChangePasswordGuard implements CanActivate {
    constructor(private subscriptionService: SubscriptionService) {}

    canActivate(): boolean {
        return !this.subscriptionService.currentSubscription?.loginSettings?.defaultLoginOptions?.disableLogin;
    }
}
